import PropTypes from 'prop-types';
import useStyles from './styles';
import {
  Drawer,
  IconButton,
  Typography,
  Box,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import Dynamicore from 'services/dynamicore';
import { useSnackbar } from 'notistack';
import { hasPermissions } from 'utils/permissions';
import { TABS } from './constants';
import ChatComponent from '../../components/Chat';
function NoteLayout({ children }) {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [tab, setTab] = useState();
  const location = useLocation();
  const history = useHistory();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [chatMessages, setChatMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);

  const handleCloseDrawer = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('notes');

    history.replace({
      ...history.location,
      search: searchParams.toString(),
    });

    setDrawerOpen(false);
  };

  const handleSaveNote = async (value, valueId) => {
    let response, message, variant = 'success';

    try {
      if (valueId) {
        [response] = await Dynamicore(tab.url).put({
          id: valueId,
          type: tab.value,
          type_id: id,
          notes: value,
        });
        message = 'Nota actualizada correctamente';
      } else {
        response = await Dynamicore(tab.url).post({
          type: tab.value,
          type_id: id,
          notes: value,
        });
        message = 'Nota guardada correctamente';
      }

      return {
        id: response?.id,
        text: response?.notes,
        date: response?.created_at,
        user: response.name || response?.username || response?.user,
      };

    } catch (error) {
      message =
        process.env.NODE_ENV === 'development' && error.message
          ? error.message
          : 'Error al guardar la nota';
      variant = 'error';
    } finally {
      enqueueSnackbar(message, {
        variant,
      });
    }
  };

  const handleRemoveNote = async function (id) {
    let message, variant = 'success';

    try {
      await Dynamicore(tab.url)
        .delete({
          id,
        }, true);

      message = 'La nota ha sido eliminado';
    } catch (error) {
      message = 'Error al eliminar la nota';
      variant = 'error';
    } finally {
      enqueueSnackbar(message, {
        variant,
      });
    }
  };

  const loadData = async function (pagination) {
    if (pagination && chatMessages?.messages?.length / pagination?.limit > pagination?.page) return;

    setIsLoading(true);
    setLoadError(false);

    const pathLocation = location.pathname.split('/').filter((segment) => segment !== '')?.[0];
    const selectedTab = TABS.find((tab) => tab.tab === pathLocation);

    setTab(selectedTab);

    try {
      const {
        values = [],
        total = 0,
      } = await Dynamicore(selectedTab.url).get({
        type_id: id,
        limit: pagination?.limit ?? 15,
        page: pagination?.page ?? 1,
        enabled: 1,
      });

      const newMessages = values.map((message) => ({
        id: message.id,
        text: message.notes,
        date: message.created_at,
        user: message.name || message.username,
      })).reverse();

      setChatMessages(() => ({
        messages: newMessages,
        total,
      }));

      return newMessages;
    } catch {
      setLoadError(true);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const pathLocation = location.pathname.split('/').filter(Boolean)?.[0];
    setTab(TABS.find((tab) => tab.tab === pathLocation));
    loadData();
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const notesParam = searchParams.get('notes');

    if (notesParam === 'true') {
      setDrawerOpen(true);
    } else {
      setDrawerOpen(false);
    }
  }, [location.search]);

  return (
    <Box className={classes.root} style={{
      marginRight: drawerOpen ? 400 : 0,
      transition: 'margin 0.3s ease',
    }}>
      {/* Drawer para agregar nota */}
      <Drawer
        variant="persistent"
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{
          style: {
            width: 400,
            paddingTop: '130px',
            overflow: 'hidden',
          },
        }}
      >
        <Box style={{
          position: 'absolute',
          top: 60,
          width: '100%',
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '15px 16px 10px',
          zIndex: 10,
        }}>
          <Typography variant='h3'>Notas</Typography>
          <IconButton onClick={handleCloseDrawer}>
            <CloseIcon />
          </IconButton>
        </Box>

        <ChatComponent
          messages={chatMessages.messages}
          onSend={handleSaveNote}
          onEdit={handleSaveNote}
          onDelete={handleRemoveNote}
          loadMore={loadData}
          isLoading={isLoading}
          loadError={loadError}
          totalMessages={chatMessages.total}
          permissions={{
            add: hasPermissions('notes.select.addNotes'),
            edit: hasPermissions('notes.select.editNotes'),
            delete: hasPermissions('notes.select.deleteNotes'),
          }}
        />
      </Drawer>

      {children}
    </Box>
  );
}

NoteLayout.propTypes = {
  children: PropTypes.node,
};

export default NoteLayout;
